class SubGroupModel {
    subGroupId?: number;
    name?: string;
    shortName?: string;
    color?: string;
    mainGroupId: number;
    mainGroupName?: string; 
    productTaxId?: number;
    productTaxName?:string;
    sgstPercentage?:number;
    cgstPercentage?: number;
    igstPercentage?: number;
    displayOrder?:number;
    isActive?:boolean;
   
}
export default SubGroupModel;